// Simple Portfolio Configuration
// Update this file with your personal information

export interface PortfolioData {
  name: string;
  headline: string;
  summary: string;
  location: string;
  profilePicture: string;
  experience: {
    title: string;
    company: string;
    duration: string;
    description: string;
  }[];
  skills: string[];
  posts: {
    id: string;
    title: string;
    content: string;
    timestamp: string;
    likes: number;
    comments: number;
    shares: number;
    hashtags: string[];
    externalLink?: string;
  }[];
  socialLinks: {
    linkedin: string;
    github: string;
    email: string;
    medium: string;
  };
}

export const portfolioData: PortfolioData = {
  // Personal Information
  name: 'Anup Adhikari',
  headline: 'Cybersecurity Enthusiast | Ethical Hacker | Founding Member of Y3ti@Sec',
  summary: 'Passionate cybersecurity professional with expertise in ethical hacking, vulnerability assessment, and security research.',
  location: 'Nepal',
  profilePicture: '/profile.jpeg',
  
  // Work Experience
  experience: [
    {
      title: 'Founding Member',
      company: 'Y3ti@Sec',
      duration: '2024 - Present',
      description: 'Co-founded cybersecurity community focused on knowledge sharing and skill development.'
    },
    {
      title: 'College Representative',
      company: 'Code For Change',
      duration: 'Jan 2025 - Present',
      description: 'Representing the college in the Code For Change community.'
    }
    // {
    //   title: 'Community Representative',
    //   company: 'Nonprofit Organization',
    //   duration: '2024 - Present',
    //   description: 'Promoting cybersecurity awareness and education.'
    // }
  ],
  
  // Skills
  skills: [
    'Web Security',
    'Penetration Testing',
    'Vulnerability Assessment',
    'Ethical Hacking',
    'XSS',
    'SQL Injection',
    'OWASP',
    //'Bug Bounty',
    'Network Security',
    'Security Research',
    'CTF Challenges'
    //'Reverse Engineering'
  ],
  
  // CTF Writeups and Security Research
  posts: [
    {
      id: '1',
      title: 'CTF Write-up: Odyssey - NahamCon 2025',
      content: 'Detailed walkthrough of the Odyssey challenge from NahamCon 2025 CTF. This writeup covers the exploitation techniques, tools used, and step-by-step solution for this cybersecurity challenge.',
      timestamp: '2025-01-15',
      likes: 45,
      comments: 12,
      shares: 5,
      hashtags: ['CTF', 'NahamCon', 'Writeup', 'Cybersecurity'],
      externalLink: 'https://medium.com/@adhikarianup/ctf-write-up-odyssey-nahamcon-2025-6ad2b8ca22e0'
    },
    {
      id: '2',
      title: 'SQL Injection: From Basics to Advanced Techniques',
      content: 'Comprehensive guide on SQL injection attacks, detection methods, and secure coding practices.',
      timestamp: '2024-01-10',
      likes: 32,
      comments: 8,
      shares: 3,
      hashtags: ['SQLInjection', 'DatabaseSecurity', 'PenetrationTesting'],
      externalLink: 'https://medium.com/@adhikarianup'
    },
    {
      id: '3',
      title: '#111DaysOfLearningForChange - Day 45',
      content: 'Today\'s focus: Advanced web application security testing. Learned about OWASP Top 10 and practical exploitation techniques.',
      timestamp: '2024-01-05',
      likes: 28,
      comments: 6,
      shares: 2,
      hashtags: ['LearningChallenge', 'WebSecurity', 'OWASP'],
      externalLink: 'https://medium.com/@adhikarianup'
    }
  ],

  // Social Media Links
  socialLinks: {
    linkedin: 'https://www.linkedin.com/in/adhikarianup',
    github: 'https://github.com/Anup0118',
    email: 'adhikari.anup2018@gmail.com',
    medium: 'https://medium.com/@adhikarianup'
  }
}; 